module.exports = __webpack_public_path__ + "img/ring-network.ad596ca0.svg";